export default from './category-page';



// WEBPACK FOOTER //
// ./app/containers/category-page/index.js